import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { defineMessage, useIntl } from 'react-intl';

/** Anchors the theme tour to the account row trigger (menu contains ThemeToggle). */
export const THEME_TOGGLE_TOUR_ELEMENT_ID = 'theme-toggle-btn';

/**
 * Runs the one-time tour for dark mode via the account menu if not yet seen and before expiry.
 */
export function useThemeToggleTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour({ key: 'sidenavThemeToggle', expiry: '2026-07-30' }, {
    steps: [
      {
        element: `#${THEME_TOGGLE_TOUR_ELEMENT_ID}`,
        popover: {
          title: $t(
            defineMessage({
              id: 'core.sidenav.themeToggle.tour.title',
              defaultMessage: 'Opciones de tema disponibles',
            }),
          ),
          description: $t(
            defineMessage({
              id: 'core.sidenav.themeToggle.tour.description',
              defaultMessage: 'Abrí el menú de cuenta para elegir Default, Oscuro o Claro.',
            }),
          ),
          side: 'right',
          align: 'start',
        },
      },
    ],
  } satisfies TourConfig);
}
